export const selectAllFocusable = (root: HTMLElement | null): HTMLElement[] => {
  return Array.from(
    (root || document).querySelectorAll(
      'a[href], button:not(:disabled), input, textarea, select, details, [tabindex]:not([tabindex="-1"])',
    ),
  );
};
